import React, { useState, useEffect } from 'react';
import  DeleteConfirmDialog  from './DeleteConfirmDialog';
import { Button, Card, Col, Container, Form, Modal, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { PencilIcon, PersonAddIcon } from '@primer/octicons-react'
import { BiPlus, BiTrash } from "react-icons/bi";
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import './AdminPages.css';
import configInfo from '../config/config.json';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';


const UserGroupAdminDetailsView = (props) => {

  // Utilities
  const { i18n, t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [userGroupAttrs, setUserGroupAttrs] = useState({
    id: '',
    name: '',
    nameLang2: '',
    nameLang3: '',
    description: '',
    creatorUsername: '',
    timeCreated: '',
    updaterUsername: '',
    timeUpdated: ''
  });

  const [currentUserGroupAttrs, setCurrentUserGroupAttrs] = useState({});

  const [memberList, setMemberList] = useState([]);
  const [newMemberCandidateList, setNewMemberCandidateList] = useState();
  const [showUserSelector, setShowUserSelector] = useState(false);

  const [roleList, setRoleList] = useState([]);
  const [rolePermList, setRolePermList] = useState([]);

  const [showRoleInfo, setShowRoleInfo] = useState(false);
  const [roleSelected, setRoleSelected] = useState();

  const [roleAddList, setRoleAddList] = useState([]);
  const [unassignedRoleList, setUnassignedRoleList] = useState();
  const [showAddRoleDialog, setShowAddRoleDialog] = useState(false);


  // UI Functions

  // Initialize state
  useEffect(() => {
    if (props) {
      setUserGroupAttrs(props.objDetails);
      setCurrentUserGroupAttrs(props.objDetails);

      fetchAssociatedRoles(props.objDetails.id);

      fetchMembers(props.objDetails.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const fetchAssociatedRoles = (userGroupId) => {

    if (!userGroupId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("usergroups/" + userGroupId + "/roles");

        resolve(res.data);
        if (res.status === 200) {
          setRoleList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const fetchRolePermisions = (roleId) => {

    if (!roleId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("roles/" + roleId + "/permissions");

        resolve(res.data);

        if (res.status === 200) {
          setRolePermList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const fetchUnassignedRoles = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("roles");

        resolve(res.data);

        if (res.status === 200) {
          // Remove roles already assigned to the user
          let roleIdsArray = [];

          for (let i=0; i<roleList.length; i++) {
            roleIdsArray.push(roleList[i].id);
          }

          let unassignedRolesArray = [];

          for (let i=0; i<res.data.length; i++) {
            if (!roleIdsArray.includes(res.data[i].id)) {
              unassignedRolesArray.push(res.data[i]);
            }
          }

          setUnassignedRoleList(unassignedRolesArray);
        }

        setErrMsg(''); //### NEED TO FIX
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));  //### NEED TO FIX
      }
    });
  }

  const fetchMembers = (userGroupId) => {

    if (!userGroupId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("usergroups/" + userGroupId + "/members");

        resolve(res.data);

        if (res.status === 200) {
          setMemberList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const fetchNewMemberCandidates = (userGroupId) => {

    if (!userGroupId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        //const res = await axiosAuth_IDENT_MGMT_API.get("usergroups/" + userGroupId + "/nonmembers");
        const res = await axiosAuth_IDENT_MGMT_API.get("users/");

        resolve(res.data);

        if (res.status === 200) {

          // Create non-member list
          let nonmemberList = [];

          for (let i=0; i<res.data.length; i++) {
            let foundUser = memberList.find(item => item.id === res.data[i].id);

            if (foundUser == null) {
              nonmemberList.push(res.data[i]);
            }
          }

          //setNewMemberCandidateList(res.data);
          setNewMemberCandidateList(nonmemberList);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg,        setErrMsg]        = useState('');
  const [addRoleErrMsg, setAddRoleErrMsg] = useState('');


  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setUserGroupAttrs({ ...userGroupAttrs, [e.target.name]: e.target.value })
  }


  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setUserGroupAttrs(currentUserGroupAttrs);

    setErrMsg('');
    setEditMode(false);
  }

  const handleEditSubmit = (e) => {

    e.preventDefault();

    // Validate paraneters

    if (!userGroupAttrs.name || userGroupAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
    } else if (userGroupAttrs.name.length > 100) {
      setErrMsg(t("I18N_Name") + " - " + t("I18N_ERR_Max_len") + "100");

    } else if (!userGroupAttrs.nameLang2 || userGroupAttrs.nameLang2.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name") + " (" + t("custom:I18N_Language_2") + ")");
    } else if (userGroupAttrs.nameLang2.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ") - " + t("I18N_ERR_Max_len") + "100");

    } else if (!userGroupAttrs.nameLang3 || userGroupAttrs.nameLang3.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name") + " (" + t("custom:I18N_Language_3") + ")");
    } else if (userGroupAttrs.nameLang3.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ") - " + t("I18N_ERR_Max_len") + "100");

    } else if (!userGroupAttrs.description || userGroupAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (userGroupAttrs.description.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + "250");

    } else {
      validateNames();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateNames() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get ("usergroups" +
                            "?nameExist="      + (currentUserGroupAttrs.name      !== userGroupAttrs.name      ? userGroupAttrs.name      : "") +
                            "&nameLang2Exist=" + (currentUserGroupAttrs.nameLang2 !== userGroupAttrs.nameLang2 ? userGroupAttrs.nameLang2 : "") +
                            "&nameLang3Exist=" + (currentUserGroupAttrs.nameLang3 !== userGroupAttrs.nameLang3 ? userGroupAttrs.nameLang3 : ""));

        resolve(res.data);

        if ((res.status === 200) && (res.data.length > 0)) {
          // UserGroup code is taken
          setErrMsg(t("I18N_ERR_UserGroupName_taken"));
          return;
        } else {
          validateOtherFields();
          return;
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs

    updateUserGroup();
  }

  const updateUserGroup = () => {

    const reqBody = userGroupAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.put("usergroups/" + userGroupAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          //setCurrentUserGroupAttrs(userGroupAttrs);
          refreshUserGroupAttrs(userGroupAttrs.id);

          // Restore UI to viewing mode
          setEditMode(false);
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });

  }


  const refreshUserGroupAttrs = (userGroupId) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("usergroups/" + userGroupId);

        resolve(res.data);

        if (res.status === 200) {

          setUserGroupAttrs(res.data[0]);
          setCurrentUserGroupAttrs(res.data[0]);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  const handleAddRole = (e) => {
    fetchUnassignedRoles();
    setShowAddRoleDialog(true);
  }

  function handleAddRolesClose() {
    setRoleAddList([]);
    setShowAddRoleDialog(false);
  }

  function handleAddRolesSubmit() {
    let roleIds = [];

    if (roleAddList.length === 0) {
      setShowAddRoleDialog(false);
      return;
    }
      
    for (let i=0; i<roleAddList.length; i++) {
      roleIds.push(parseInt(roleAddList[i]));
    }

    let reqBody = {
          roleIds: roleIds
        };

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_IDENT_MGMT_API.post("usergroups/" + userGroupAttrs.id + "/roles", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setRoleAddList([]);
          setAddRoleErrMsg('');
          setShowAddRoleDialog(false);
          fetchAssociatedRoles(userGroupAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setAddRoleErrMsg(t(translateAPIError(error)));
      }
    });
  }

  function handleRoleInfo(role) {
    // Fetch permissions associated with the selected role
    fetchRolePermisions(role.id);

    setRoleSelected(role);
    setShowRoleInfo(true);
  }

  function handleAddMember() {
    fetchNewMemberCandidates(userGroupAttrs.id);
    setShowUserSelector(true);
  }

  function handleUserSelectorClose() {
    setShowUserSelector(false);
  }


  function handleNewMemberSubmit(e, user) {
    // Add a member
    const reqBody =
            {
              "userId": user.id
            };

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.post("usergroups/" + userGroupAttrs.id + "/user",
                                                   reqBody);

        resolve(res.data);

        if (res.status === 200) {
          // Add the new member to the member list
          fetchMembers(userGroupAttrs.id);
          setShowUserSelector(false);
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const handleRoleInfoClose = (e) => {
    setRoleSelected(null);
    setShowRoleInfo(false);
  }

  const handleRoleSelect = (e) => {

    if (e.target.checked) {
      // Add role to the list 
      roleAddList.push(e.target.id);
    } else {
      const index = roleAddList.indexOf(e.target.id);
      if (index > -1) {
        roleAddList.splice(index, 1);
      }    
    }    

    setRoleAddList(roleAddList);
  }

  function renderRole(role, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>
          <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleRoleInfo(role)}>
            { (i18n.language === 'en') ? role.name : (i18n.language === 'zh_HK' ? role.nameLang2 : role.nameLang3) }
          </span>
        </td>
        <td>{role.description}</td>
        { configInfo.appConfig.isPrimaryIdentProvider ?
          <td>
            <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_Remove_role")}</Tooltip>}>
              <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleRemoveRole(role)}><BiTrash size={16} /></span>
            </OverlayTrigger>
          </td>
        :
          null
        }
        <td></td>
      </tr>
    )
  }

  function renderRolePerm(perm, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>{perm.nameCode}</td>
        <td>{perm.description}</td>
      </tr>
    )
  }

  function renderAddRoles(role, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width:"5%"}} ><Form.Check type="checkbox" id={role.id} label="" onChange={handleRoleSelect} /></td>
        <td style={{width:"35%"}} >
          <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleRoleInfo(role)}>
            { (i18n.language === 'en') ? role.name : (i18n.language === 'zh_HK' ? role.nameLang2 : role.nameLang3) }
          </span>
        </td>
        <td style={{width:"60%"}} >{role.description}</td>
      </tr>
    )    
  }

  function renderMember(member, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>{member.username}</td>
        <td>{member.surname}, {member.givenName} {member.middleName}</td>
        <td>
         { (i18n.language === 'en') ? member.deptName : (i18n.language === 'zh_HK' ? member.deptNameLang2 : member.deptNameLang3) }
        </td>
        <td>{formatDate(member.timeJoined)}</td>
        <td>{member.addedBy}</td>
        { configInfo.appConfig.isPrimaryIdentProvider ?
          <td>
            <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_Remove_member")}</Tooltip>}>
              <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleDeleteMember(member)}><BiTrash size={16} /></span>
            </OverlayTrigger>
          </td>
        :
          null
        }
        <td></td>
      </tr>
    )
  }


  function renderUser(user, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{maxWidth:'120px', flexWrap: 'wrap', wordWrap: 'break-word'}}>{user.username}</td>
        <td style={{maxWidth:'180px', flexWrap: 'wrap', wordWrap: 'break-word'}}>
          {(user.surname ? user.surname + ', ' : '')} {user.givenName} {user.middleName}</td>
        <td style={{maxWidth:'100px', minWidth: '100px', flexWrap: 'wrap', wordWrap: 'break-word'}}>
           { (i18n.language === 'en') ? user.deptName : (i18n.language === 'zh_HK' ? user.deptNameLang2 : user.deptNameLang3) }
        </td>
        <td style={{minWidth:'60px', flexWrap: 'wrap', wordWrap: 'break-word'}}>
          <span>
            <Button size="tiny" variant="outline-secondary"
              style={{ float: 'left' }}
              onClick={(e) => {handleNewMemberSubmit(e, user)}}>
              {t("I18N_Add")}
            </Button>
          </span>
        </td>
      </tr>
    )
  }


  // Role delete confirmation dialog stuff

  const [showRoleDeleteDialog,   setShowRoleDeleteDialog]   = useState(false);
  const [roleDeleteTarget,       setRoleDeleteTarget]       = useState(null);
  const [errMsgDeleteConfirm,    setErrMsgDeleteConfirm]    = useState('');

  function handleRemoveRole(role) {
    setRoleDeleteTarget(role);
    setShowRoleDeleteDialog(true);
  }

  function handleRemoveRoleCancel(role) {
    setRoleDeleteTarget(null);
    setShowRoleDeleteDialog(false);
  }

  function handleRemoveRoleSubmit() {

    let reqBody = {
          data: {
             "roleIds": []
          }
        };

    reqBody.data.roleIds.push(roleDeleteTarget.id);

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_IDENT_MGMT_API.delete("usergroups/" + userGroupAttrs.id + "/roles/", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsgDeleteConfirm('');
          setShowRoleDeleteDialog(false);
          fetchAssociatedRoles(userGroupAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setErrMsgDeleteConfirm(t(translateAPIError(error)));
      }
    });
  }



  // Member delete / User delete confirmation dialog stuff

  const [showMemberDeleteDialog, setShowMemberDeleteDialog] = useState(false);
  const [memberDeleteTarget,     setMemberDeleteTarget]     = useState(null);

  function handleDeleteMember(user) {
    setMemberDeleteTarget(user);
    setShowMemberDeleteDialog(true);
  }

  function handleRemoveMemberCancel() {
    setMemberDeleteTarget(null);
    setShowMemberDeleteDialog(false);
  }

  function handleRemoveMemberSubmit() {

    // Remove the member from the group
    let reqBody = {
          data: {
             "userIds": []
          }
        };

    reqBody.data.userIds.push(memberDeleteTarget.id);

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.delete("usergroups/" + userGroupAttrs.id + "/users/", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          fetchMembers(userGroupAttrs.id);
          setErrMsgDeleteConfirm('');
          setShowMemberDeleteDialog(false);
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  // Main UI

  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_UGroup_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_UGroup_info")}
            </span>
            {editMode || !configInfo.appConfig.isPrimaryIdentProvider ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>

          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_UGroup_name")}: *</Col>
                  { configInfo.uiConfig.visibleFields.UGROUP_NameLang2 ?
                    <Col>{t("I18N_UGroup_name") + "(" + t("custom:I18N_Language_2") + ")"}: *</Col>
                  : null
                  }
                  { configInfo.uiConfig.visibleFields.UGROUP_NameLang3 ?
                    <Col>{t("I18N_UGroup_name") + "(" + t("custom:I18N_Language_3") + ")"}: *</Col>
                  : null
                  }
                  <Col>{t("I18N_Description")}: *</Col>
                  { !configInfo.uiConfig.visibleFields.UGROUP_NameLang2 ?
                    <Col></Col>
                  : null
                  }
                  { !configInfo.uiConfig.visibleFields.UGROUP_NameLang3 ?
                    <Col></Col>
                  : null
                  }
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={userGroupAttrs.name}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  { configInfo.uiConfig.visibleFields.UGROUP_NameLang2 ?
                    <Col>
                      <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="nameLang2" value={userGroupAttrs.nameLang2}
                        onChange={(e) => onAttrsInputChange(e)} />
                    </Col>
                  : null
                  }
                  { configInfo.uiConfig.visibleFields.UGROUP_NameLang3 ?
                    <Col>
                      <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="nameLang3" value={userGroupAttrs.nameLang3}
                        onChange={(e) => onAttrsInputChange(e)} />
                    </Col>
                  : null
                  }
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={userGroupAttrs.description}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  { !configInfo.uiConfig.visibleFields.UGROUP_NameLang2 ?
                    <Col></Col>
                  : null
                  }
                  { !configInfo.uiConfig.visibleFields.UGROUP_NameLang3 ?
                    <Col></Col>
                  : null
                  }
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_UGroup_name")}:</Col>
                { configInfo.uiConfig.visibleFields.UGROUP_NameLang2 ?
                  <Col>{t("I18N_UGroup_name") + "(" + t("custom:I18N_Language_2") + ")"}:</Col>
                : null
                }
                { configInfo.uiConfig.visibleFields.UGROUP_NameLang3 ?
                  <Col>{t("I18N_UGroup_name") + "(" + t("custom:I18N_Language_3") + ")"}:</Col>
                : null
                }
                <Col>{t("I18N_Description")}:</Col>
                { !configInfo.uiConfig.visibleFields.UGROUP_NameLang2 ?
                  <Col></Col>
                : null
                }
                { !configInfo.uiConfig.visibleFields.UGROUP_NameLang3 ?
                  <Col></Col>
                : null
                }
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{userGroupAttrs.name}</Col>
                { configInfo.uiConfig.visibleFields.UGROUP_NameLang2 ?
                  <Col>{userGroupAttrs.nameLang2}</Col>
                : null
                }
                { configInfo.uiConfig.visibleFields.UGROUP_NameLang3 ?
                  <Col>{userGroupAttrs.nameLang3}</Col>
                : null
                }
                <Col>
                  <textarea readOnly className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={userGroupAttrs.description} />
                </Col>
                { !configInfo.uiConfig.visibleFields.UGROUP_NameLang2 ?
                  <Col></Col>
                : null
                }
                { !configInfo.uiConfig.visibleFields.UGROUP_NameLang3 ?
                  <Col></Col>
                : null
                }
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{userGroupAttrs.creatorUsername}</Col>
                <Col>{formatDate(userGroupAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{userGroupAttrs.updaterUsername}</Col>
                <Col>{formatDate(userGroupAttrs.timeUpdated)}</Col>
              </Row>
            </Container>
          }
        </div>


        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'30px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_Roles_assigned_to_group")}
            </span>

            { configInfo.appConfig.isPrimaryIdentProvider ?
              <span style={{marginLeft:'auto', marginRight:'20px'}}>
                <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_role_to_grp")}</Tooltip>}>
                  <span onClick={handleAddRole} style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                    <BiPlus size={18} />
                  </span>
                </OverlayTrigger>
              </span>
            :
              null
            }

          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>

            <Table hover responsive size="sm">
              <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                <tr>
                  <th style={{width:'20%', fontWeight:'400'}}>{t("I18N_Role_name")}</th>
                  <th style={{width:'75%', fontWeight:'400'}}>{t("I18N_Description")}</th>
                  <th style={{width:'5%'}}></th>
                </tr>
              </thead>
              <tbody>
                {(roleList && roleList.length > 0) ? roleList.map(renderRole) : null}
              </tbody>
            </Table>
          </div>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'30px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_Member_users")}
            </span>

            { configInfo.appConfig.isPrimaryIdentProvider ?
              <span style={{marginLeft:'auto', marginRight:'20px'}}>
                <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_member_to_grp")}</Tooltip>}>
                  <span onClick={handleAddMember} style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                    <PersonAddIcon size={18} />
                  </span>
                </OverlayTrigger>
              </span>
            :
              null
            }
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px', maxHeight:'400px'}}>

            <Table hover responsive size="sm">
              <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                <tr>
                  <th style={{width:'20%', fontWeight:'400'}}>{t("I18N_Username")}</th>
                  <th style={{width:'25%', fontWeight:'400'}}>{t("I18N_Full_name")}</th>
                  <th style={{width:'20%', fontWeight:'400'}}>{t("I18N_Dept_name")}</th>
                  <th style={{width:'15%', fontWeight:'400'}}>{t("I18N_Time_joined_grp")}</th>
                  <th style={{width:'15%', fontWeight:'400'}}>{t("I18N_Added_by")}</th>
                  <th style={{width:'5%'}}></th>
                </tr>
              </thead>
              <tbody>
                {memberList.map(renderMember)}
              </tbody>
            </Table>
          </div>
        </div>


        <div className={classes.admin_pages__page_subtitle}>
          <Form.Group as={Row} className="mb-2 mt-3">
            <Col sm={{span: 2}}>
              <Button size="sm" variant="outline-secondary"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </Col>
{/*
            <Col sm="10", offset: 2>
              <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {updateUserGroupErrMsg}
              </span>
            </Col>
*/}
          </Form.Group>
        </div>


        <Modal show={showRoleInfo} onHide={handleRoleInfoClose} centered >
          <Modal.Body>
{/*
            <div style={{display:'flex'}}>
              <span style={{fontSize:'16px', fontWeight:'200'}}>
                {t("I18N_Role_name")}:
              </span>
              <span style={{fontSize:'17px', fontWeight:'250', marginLeft:'10px'}}>
                FM Technician
              </span>
            </div>
*/}
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <div display='flex'>
                <span>
                  {t("I18N_Role_info")}
                </span>
              </div>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

              <Container>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Role_name")}:</Col>
                  <Col>{t("I18N_Description")}:</Col>
                </Row>
                  {roleSelected ?
                    <>
                      <Row className={classes.admin_pages__field_value}>
                        <Col>
                          { (i18n.language === 'en') ? roleSelected.name : (i18n.language === 'zh_HK' ? roleSelected.nameLang2 : roleSelected.nameLang3) }
                        </Col>
                        <Col>
                          <textarea readOnly rows={3} className={classes.admin_pages__field_editable} style={{resize:'none', borderStyle:'none', width:'100%'}}
                            name="description" value={roleSelected.description} />
                        </Col>
                      </Row>
                    </>
                  :
                    <></>
                  }
              </Container>


              <div display='flex'>
                <span>
                  {t("I18N_Permissions")}
                </span>
              </div>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
            </div>

            <div style={{overflow:'auto', maxHeight:'500px', fontSize:'11px', marginTop:'10px'}}>
              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th style={{fontWeight:'400'}}>{t("I18N_Perm_code")}</th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {rolePermList.map(renderRolePerm)}
                </tbody>
              </Table>
            </div>

            <div>
              <Button size="sm" variant="outline-secondary"
                style={{ marginBottom:'5px', fontSize:'12px', fontWeight:'300' }}
                onClick={handleRoleInfoClose}>
                {t("I18N_Close")}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showUserSelector} onHide={handleUserSelectorClose} centered >
          <Modal.Body>

            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <div display='flex'>
                <span>
                  {t("I18N_Users")}
                </span>
              </div>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
            </div>

            <div style={{overflow:'auto', maxHeight:'500px', fontSize:'11px', marginTop:'10px'}}>
              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr style={{maxWidth:'300px'}}>
                    <th style={{fontWeight:'400'}}>{t("I18N_Username")}</th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Full_name")}</th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Dept_name")}</th>
                    <th style={{fontWeight:'400'}}></th>
                  </tr>
                </thead>
                <tbody>
                  {newMemberCandidateList? newMemberCandidateList.map(renderUser) : null}
                </tbody>
              </Table>
            </div>

            <div style={{marginTop:'10px'}}>
              <Button size="sm" variant="outline-secondary"
                style={{ float: 'right', marginBottom:'5px', fontSize: '12px', fontWeight: '300' }}
                onClick={handleUserSelectorClose}>
                {t("I18N_Close")}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showAddRoleDialog} onHide={handleAddRolesClose} centered >
          <Modal.Body style={{height:'700px', overflow:'auto'}}>

            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <div display='flex'>
                <span>
                  {t("I18N_Roles")}
                </span>
              </div>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
            </div>

            <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>
              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th style={{width:"5%"}}></th>
                    <th style={{width:"35%", fontWeight:'400'}}>{t("I18N_Role_name")}</th>
                    <th style={{width:"60%", fontWeight:'400'}}>{t("I18N_Description")}</th>
                  </tr>
                </thead>
                <tbody>
                  {unassignedRoleList? unassignedRoleList.map(renderAddRoles) : null}
                </tbody>
              </Table>
            </div>

            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleAddRolesClose}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleAddRolesSubmit}>
                {t("I18N_Assign_roles")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {addRoleErrMsg}
              </span>
            </div>
          </Modal.Body>
        </Modal>

        <DeleteConfirmDialog
          title={t("I18N_Role_remove_confirm")}
          show={showRoleDeleteDialog}
          targetName=
            { roleDeleteTarget ? ((i18n.language === 'en') ? roleDeleteTarget.name :
                                  (i18n.language === 'zh_HK' ? roleDeleteTarget.nameLang2 : roleDeleteTarget.nameLang3)) : '' }
          errMsgDeleteConfirm={errMsgDeleteConfirm}
          onCancel={handleRemoveRoleCancel}
          onSubmit={handleRemoveRoleSubmit}
        />

        <DeleteConfirmDialog
          title={t("I18N_Member_remove_confirm")}
          show={showMemberDeleteDialog}
          targetName={ memberDeleteTarget ? memberDeleteTarget.username : '' }
          errMsgDeleteConfirm={errMsgDeleteConfirm}
          onCancel={handleRemoveMemberCancel}
          onSubmit={handleRemoveMemberSubmit}
        />

      </Card>
    </>
  );
}
 
export default UserGroupAdminDetailsView;
